<template>
  <div class="contact content-width">
    <a class="button" href="https://www.github.com/andreyrd" target="_blank">
      <img src="@/assets/github.svg" alt="Github">
    </a>
    <a class="email button" href="mailto:andrey@andreyrd.com">Contact Me</a>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" fixed>
@import '@/styles/colors.scss';
@import '@/styles/sizes.scss';

.contact {
  position: fixed;
  right: 0;
  bottom: 24px;
  left: 0;

  &::before {
    content: '';
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    height: 90px;
    background: linear-gradient(rgba($color-bg, 0.1) 0%, rgba($color-bg, 1) 2%, $color-bg);
  }
}

.button {
  display: inline-block;
  margin: 0 4px;
  padding: 0 12px;
  transform: scale(0.97);
  background: rgba($color-fg, 0.2);
  color: white;
  line-height: 48px;
  text-decoration: none;
  border-radius: 16px;
  transition: all 1s;
  vertical-align: middle;

  &:hover {
    transform: scale(1);
    border-radius: 12px;
  }

  img {
    width: 24px;
    height: 24px;
    vertical-align: -7px;
  }
}

.email {
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 24px;
}
</style>
